import {CustomerFieldKeys, getValue} from '../../support/get_data';
import {useAppSelector} from '../../store/store';
import {__, transString} from '../../support/lang/translations';
import {CustomSelect} from '../select/select.tsx';
import {Country} from '../../enums/customer_fields/Country.ts';
import {SingleValue} from 'react-select';

interface CountryOption {
    label: string;
    value: string;
}

interface OwnProps {
    isLoading: boolean;
    isLocked: boolean;
    onChange: (e: string) => void;
}

export function CountrySelect(props: OwnProps) {
    const meData = useAppSelector((state) => state.customerInfo.me?.customer);

    const countryData = getValue(meData, CustomerFieldKeys.COUNTRY);

    const countryOptions: CountryOption[] = Object.values(Country).map((country) => {
        return {
            label: transString('enums.country.' + country),
            value: country.valueOf(),
        };
    });
    const selectedCountryOption = countryOptions?.find((lo) => lo != null && lo.value === countryData?.value);

    return (
        <label>
            {countryData?.name ?? __('profile.fields.country')}
            <CustomSelect<CountryOption>
                name={countryData?.key ?? CustomerFieldKeys.COUNTRY}
                isSearchable={false}
                options={countryOptions}
                defaultValue={selectedCountryOption}
                isDisabled={props.isLoading}
                isLocked={props.isLocked}
                onChange={(e: SingleValue<CountryOption>) => props.onChange(e?.value ?? '')}
            />
        </label>
    );
}
